export const servicesdata = [
  {
    id: 1,
    name: "Technology Services",
    img: require("../../src/Images/Technology Services.png"),
    content:
      "Our technology services deliver full-stack quantum and AI solutions, combining hardware, software, and hybrid computing to enable scalable, secure, and high-performance systems across industries.",
  },
  // {
  //     id:2,
  //     name:"Consultancy Services",
  //     img:require("../../src/Images/Consultancy Servicess.png"),
  //     content:"Organisations can consult us for a product market fit to understand and implement quantum and AI technologies for their business growth.",
  // },
  // {
  //     id:3,
  //     name:"Training Services",
  //     img:require("../../src/Images/Training Services.png"),
  //     content:"We enable organisations and individuals to understand quantum and Al technologies by providing a flexible hands-on training to kick start their deep tech journey.",
  // },
  // {
  //     id:4,
  //     name:"Development Services",
  //     img:require("../../src/Images/Development Services.png"),
  //     content:"From concept to deployment, our team of experts provide customised solutions and support to ensure that you get the most out of these technologies.",
  // },
  // {
  //     id:5,
  //     name:"Integration Services",
  //     img:require("../../src/Images/Integration Services.png"),
  //     content:"We seamlessly integrate quantum and AI technology into your existing business operations.",
  // },
  {
    id: 6,
    name: "R&D Services",
    img: require("../../src/Images/R&D Services.png"),
    content:
      "Our R&D focuses on building real, usable innovations in quantum computing, communication, sensing, and security transforming deep-tech research into powerful, market-ready products. ",
  },
  {
    id: 7,
    name: "Security Upgrade Services",
    img: require("../../src/Images/Security Upgrade Services.png"),
    content:
      "We provide quantum-resilient security solutions, including advanced cryptography and secure communication systems, helping organizations protect their data against future quantum threats. ",
  },
  {
    id: 8,
    name: "Infrastructure Services",
    img: require("../../src/Images/Infrastructure Services.png"),
    content:
      "We design and deploy complete quantum-ready environments, including labs, demonstrator kits, and integrated systems making it easier for institutions to build and scale quantum capabilities.",
  },
];

export const benefitservicesdata=[
    {
        id:1,
        name:"Across Environments",
        img:require("../../src/Images/Across Environments.png"),
        content:"Leverage the quantum and other heterogenous classical compute resources best suited for your tasks, without getting locked into any one hardware platform.",
    },
    {
        id:2,
        name:"Data Managment & Velocity",
        img:require("../../src/Images/Data Managment & Velocity.png"),
        content:"Store, retrieve, and analyze large datasets. Streamline data management from ingestion to export to accelerate data velocity.",
    },
    {
        id:3,
        name:"Open Framework",
        img:require("../../src/Images/Open Framework.png"),
        content:"Keep what works now. Integrate existing and future solutions with a framework optimized for extensibility, interoperability, and innovation.",
    },
    {
        id:4,
        name:"Ease of Development",
        img:require("../../src/Images/Development Services.png"),
        content:"One unified platform to go from research to development to deployment with extensible, scalable, modular workflows.",
    },
   
];